import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type RadioValue = string | number | boolean;

@Component({
    selector: 'app-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioComponent),
            multi: true,
        },
    ],
})
export class RadioComponent implements ControlValueAccessor {
    @Input() id = 'radio';
    @Input() name = 'radio';
    @Input() label: string;
    @Input() hint: string;
    @Input() value: RadioValue;
    @Input() invalid = false;
    @Input() disabled = false;

    selectedValue: RadioValue | null = null;

    /* eslint-disable @typescript-eslint/no-empty-function */
    private onChangeFn: (value: RadioValue) => void = () => {};
    private onTouchedFn: () => void = () => {};
    /* eslint-enable @typescript-eslint/no-empty-function */

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    get checked(): boolean {
        return this.selectedValue === this.value;
    }

    onChange(): void {
        this.selectValue();
    }

    onLabelClick(event: MouseEvent): void {
        event.preventDefault();

        if (!this.disabled && !this.checked) {
            this.selectValue();
        }
    }

    onBlur(): void {
        this.onTouchedFn();
    }

    writeValue(value: RadioValue | null): void {
        this.selectedValue = value;
        this.changeDetectorRef.markForCheck();
    }

    registerOnChange(fn: (value: RadioValue) => void): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
        this.changeDetectorRef.markForCheck();
    }

    private selectValue(): void {
        this.selectedValue = this.value;
        this.onChangeFn(this.value);
    }
}
